import { bt } from '@/i18n/bookingI18n';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateSchedule({ date, time, lang }) {
  const e = {};
  if (!date) e.date = bt(lang, 'errDate');
  if (!time) e.time = bt(lang, 'errTime');
  return e;
}

export function validateContact({ form, lang }) {
  const e = {};
  if (!form.name.trim()) e.name = bt(lang, 'errName');
  if (!EMAIL_RE.test(form.email.trim())) e.email = bt(lang, 'errEmail');
  if (!form.phone.trim()) e.phone = bt(lang, 'errPhone');
  return e;
}
